import React, { useEffect, useState } from 'react';
import { AddCircleOutline, RemoveCircleOutline } from '@material-ui/icons';
import AddressService, { buildCapNoLocation } from './AddressComponent';
import AddressServiceNew from './AddressComponent2';

export default function MultipleReferringPlaceNew({ referringPlace, onChange, error }) {
	const [addressArray, setAddressArray] = useState([{}]);
	const [load, setLoad] = useState(false);
	function addRow() {
		const temp = addressArray;
		temp.push({});
		setAddressArray(temp);
		setLoad(!load);
	}
	useEffect(() => {
		addRow();
	}, []);
	useEffect(() => {
		const temp = [];
		// console.log({ ref: referringPlace });
		if (referringPlace?.length > 0) {
			referringPlace.forEach(e => {
				const newData = {
					region: e.region,
					province: e.province,
					city: e.location,
					location: e.location,
					caps: e.capList,
					cap: e.cap
				};
				if (e.location && e.location !== '') temp.push(newData);
			});
			setAddressArray(temp || [{}]);
		}
	}, [referringPlace, referringPlace?.length]);
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignContent: 'center',
				alignItems: 'center',
				width: '100%'
			}}
		>
			{addressArray.map((e, index) => (
				<div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
					{index === 1 && <div className="buy-form-paragraph">Altri luoghi da notificare</div>}
					<div
						key={index}
						style={{
							display: 'flex',
							alignItems: 'flex-end',
							alignContent: 'flex-end',
							width: '100%'
						}}
					>
						<RemoveCircleOutline
							style={{
								color: 'red',
								display: index <= 0 && 'none',
								marginRight: 10
							}}
							className="pointer"
							onClick={() => {
								if (index === 1 && addressArray.length <= 2) {
									const temp = addressArray;
									temp[index] = {
										region: '',
										province: '',
										location: '',
										cap: ''
									};
									setAddressArray(temp);
									onChange(JSON.stringify(temp));
									setLoad(!load);
								} else {
									const temp = addressArray;
									temp[index] = {
										region: '',
										province: '',
										location: '',
										cap: ''
									};
									temp.splice(index, 1);
									setAddressArray(temp);
									onChange(JSON.stringify(temp));
									setLoad(!load);
								}
							}}
						/>
						<AddressServiceNew
							names="obituary-graveyard"
							form={
								addressArray[index] || {
									region: '',
									province: '',
									location: '',
									cap: ''
								}
							}
							error={error}
							length={addressArray.length}
							index={index}
							setToSend={() => {
								onChange(JSON.stringify(addressArray));
								setLoad(!load);
							}}
							fullWidth
							addRow={addRow}
							forceLoad={() => setLoad(!load)}
							formError={{}}
							province={
								referringPlace?.length > 0 &&
								referringPlace[index] &&
								referringPlace[index].provinceList
							}
							comuni={
								referringPlace?.length > 0 &&
								referringPlace[index] &&
								referringPlace[index].locationList
							}
							caps={
								referringPlace?.length > 0 && referringPlace[index]
									? buildCapNoLocation(referringPlace[index].capList) || [e.cap]
									: e.cap && [e.cap]
							}
							disableCap={false}
							disableRoute={false}
						/>
					</div>
					{error && e.region && e.region !== '' && index === addressArray.length - 1 && (
						<p style={{ color: 'red', margin: 'auto', textAlign: 'center', display: 'none' }}>
							Devi selezionare almeno un luogo di riferimento (Regione, provincia e citta)
						</p>
					)}
				</div>
			))}
			{(addressArray[addressArray.length - 1].city || addressArray[addressArray.length - 1].location) && (
				<AddCircleOutline
					color="primary"
					id="add-row"
					style={{
						visibility:
							(!addressArray[addressArray.length - 1].region || addressArray.length === 1) && 'hidden'
					}}
					className="mt-3 pointer"
					onClick={addRow}
				/>
			)}
		</div>
	);
}
